import { Box, Grid, Heading, Stack, Text } from "@chakra-ui/react";
import { CtaButton, Reveal, RichText } from "@/components";
import { HERO } from "@/content";
import { HeroViewer } from "./HeroViewer";

export const Hero = () => (
  <Grid
    as="section"
    maxW="maxw"
    mx="auto"
    px="pad"
    pt="clamp(40px, 7vw, 96px)"
    pb="clamp(48px, 6vw, 88px)"
    gap="clamp(28px, 4vw, 48px)"
    templateColumns={{ base: "minmax(0, 1fr)", xl: "minmax(0, 1fr) minmax(0, 1fr)" }}
    alignItems={{ xl: "center" }}
    columnGap={{ xl: "clamp(32px, 5vw, 80px)" }}
  >
    <Reveal minW={0} gridColumn={{ xl: "1 / -1" }}>
      <Text variant="eyebrow">
        <RichText nodes={HERO.eyebrow} />
      </Text>
    </Reveal>

    <Reveal minW={0} gridColumn={{ xl: "1 / -1" }}>
      <Heading
        as="h1"
        variant="display"
        display="grid"
        minW={0}
        fontSize={{ base: "clamp(2rem, 8.2vw, 3rem)", md: "display" }}
      >
        <Box as="span" minW={0} overflowWrap="anywhere">
          {HERO.titleLines[0]}
        </Box>
        <Box as="span" minW={0} overflowWrap="anywhere" color="warm.600">
          {HERO.titleLines[1]}
        </Box>
      </Heading>
    </Reveal>

    <Reveal minW={0}>
      <Stack spacing="28px" align="start" maxW="62ch">
        <Text fontSize="lede" lineHeight={1.15} color="warm.700" maxW="34ch" sx={{ textWrap: "pretty" }}>
          {HERO.lede}
        </Text>
        <Stack direction="row" flexWrap="wrap" spacing={0} gap="12px">
          {HERO.actions.map((action) => (
            <CtaButton key={action.label} href={action.href} variant={action.variant}>
              {action.label}
            </CtaButton>
          ))}
        </Stack>
        {HERO.note && <Text variant="small">{HERO.note}</Text>}
      </Stack>
    </Reveal>

    <Reveal minW={0}>
      <Box
        as="figure"
        w="100%"
        minW={0}
        maxW={{ base: "calc(100vw - 40px)", md: "100%" }}
        position="relative"
        borderRadius="lg"
        overflow="hidden"
        bg="surface.white"
        border="1px solid"
        borderColor="line.hairline"
      >
        <HeroViewer />
        <Box
          as="figcaption"
          position="absolute"
          left={0}
          right={0}
          bottom={0}
          pt="28px"
          px="clamp(16px, 2.4vw, 28px)"
          pb="clamp(14px, 2vw, 20px)"
          fontSize="small"
          color="ink.light"
          bgGradient="linear(to-t, rgba(0, 0, 0, 0.68), transparent)"
          pointerEvents="none"
        >
          {HERO.caption}
        </Box>
      </Box>
    </Reveal>
  </Grid>
);
